export default __webpack_public_path__ + "static/media/Front-Sheyaaka-Production-House-2.decb0ca8.jpg";